// frontend/src/components/CreatePost/SubmitButton.jsx
import { Loader2, Send } from "lucide-react";

export default function SubmitButton({ loading }) {
  return (
    <button
      type="submit"
      disabled={loading}
      className="w-full bg-[#449779] text-white font-semibold py-3 rounded-xl hover:bg-[#2d5f4d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
    >
      {loading ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin" />
          Publicando...
        </>
      ) : (
        <>
          <Send className="w-5 h-5" />
          Publicar Anúncio
        </>
      )}
    </button>
  );
}